import _ from 'lodash';
import moment from 'moment';

export default {
    currency: function (value, minimumFractionDigits = 2) {
        let n = typeof value != "number" ? parseFloat(value) : value;
        return n.toLocaleString("en-US", { minimumFractionDigits });
    },
    titleCase: function (value) {
        return _.startCase(value);
    },
    uppercase: function (value) {
        return _.toUpper(value);
    },
    capitalize: function (value) {
        return _.capitalize(value);
    },
    date: function (value, format = 'D MMMM, YYYY HH:mm:ss') {
        return moment(value).format(format);
    },
    normalizeCurrency: function (value) {
        return parseInt(value.replace(/[,]+/g, ""));
    },
    walletType: function (value) {
        switch (value) {
            case 'instant_payment':
                return 'Instant Payment';
            case 'main_balance':
                return 'Personal Wallet';
            case 'credit_balance':
                return 'Company Credit';
            default:
                return '';
        }
    },
}